import AppConfirmationModal from "@components/ConfirmationModal";
import AppToggle from "@components/Toggle";
import EventBus from "@packages/event-bus/index";
import jwtDecode from "jwt-decode";
export default {
    components: {
        AppToggle,
        AppConfirmationModal
    },

    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },

    computed: {
        item() {
            return this.dataItem;
        },

        active: {
            get() {
                return this.item.isActive;
            },
            set(value) {
                this.item.isActive = value;
                if (value) {
                    this.confirmChangeActive();
                } else {
                    this.changeActive();
                }
            }
        }
    },
    data() {
        return {
            pendingChangeActive: null
        };
    },

    methods: {
        async confirmChangeActive() {
            await this.$api[this.entity].activate(this.item.id);

            EventBus.$emit("show-message", {
                type: "SUCCESS",
                message: this.$t('message.successMessages.message.operationSuccessful'),
                timeout: 3500
            });

            this.pendingChangeActive = null;
        },

        cancelChangeActive() {
            this.item.isActive = !this.item.isActive;
            this.pendingChangeActive = null;
        },

        changeActive() {
            this.pendingChangeActive = this.item;
        },

        bind() {
            EventBus.$emit("EDIT_USER_BINDINGS", this.item.id);
        },

        edit() {
            EventBus.$emit("EDIT_USER_DATA", this.item.id);
        },

        settings() {
            EventBus.$emit("EDIT_USER_SETTINGS", this.item.id);
        },

        async access() {
            const userData = await this.$api.auth.loginAs({
                id: this.item.id
            });

            this.$store.commit('SET_LOGIN_AS', true);
            localStorage.setItem('loginAs', true);

            localStorage.setItem("token", userData.token);

            sessionStorage.setItem("avatar-loginAs", userData.avatar)

            const resultToken = jwtDecode(userData.token);

            this.$store.commit("SET_TOKEN",userData.token);

            this.$store.commit("SET_USER", {
                accountId:resultToken.loggedAs.accountId,
                avatar:userData.avatar,
                id:resultToken.loggedAs.userId,
                login:resultToken.loggedAs.sub,
                logo: userData.logo ? userData.logo : "",
                nome: resultToken.loggedAs.userName,
                paginaPosAutenticacao: userData.paginaPosAutenticacao,
                permissions: resultToken.loggedAs.permissions,
                tipo: resultToken.loggedAs.accountType,
            });

            if(resultToken.accountType === "PARCEIRO" && !resultToken.loggedAs.accountType === "ESTABELECIMENTO"  || resultToken.loggedAs.accountType === "PARCEIRO"){
                location.assign("/estabelecimentos");
            }else{
                location.assign("/");
            }
        },
    },

    mounted() {
        if (!this.entity) throw new Error("Entity not specified");
    }
};
